import DOMPurify from "dompurify";

/**
 * Sanitize a string of HTML before injecting into the DOM via
 * dangerouslySetInnerHTML. Configured to keep the tags/attrs the
 * blog (TipTap) and static confirmation copy actually use, and
 * to strip anything script-like.
 */
export function sanitizeHtml(html) {
  if (html == null) return "";
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
    // Prevent DOM clobbering + strip event handlers by default (DOMPurify)
    ADD_ATTR: ["target", "rel"],
  });
}
